module.exports = __webpack_public_path__ + "static/Background-gov-4.160357cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-gov-4.jpg
// module id = 469
// module chunks = 53566712009029